import {postMethod} from '~/api'

async function post(request) {
    return await postMethod('/api/fillCarBookingData', request)
}

export {post}
